import { FC, PropsWithChildren, memo } from 'react';

const Nav: FC<PropsWithChildren> = ({ children }) => <div>{children}</div>;

export default memo(Nav);
